<div class="skl-platform-master" aria-busy="true" aria-label="Loading platform master">
  <div class="skl-header">
    <app-skeleton width="180px" height="24px" borderRadius="4px" marginBottom="0"></app-skeleton>
  </div>

  <div class="skl-toolbar">
    <app-skeleton width="180px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
  </div>

  <div class="skl-card skl-card--info">
    <div class="skl-card__body">
      <app-skeleton width="82%" height="13px" borderRadius="3px" marginBottom="8px"></app-skeleton>
      <app-skeleton width="56%" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
    </div>
  </div>

  <div class="skl-card">
    <div class="skl-card__body">
      <div class="skl-table-wrap">
        <div class="table-responsive">
          <table class="skl-table">
            <colgroup>
              <col style="width: 42%">
              <col style="width: 28%">
              <col style="width: 30%">
            </colgroup>
            <thead>
              <tr>
                @for (width of ['38%', '26%', '20%']; track width) {
                  <th>
                    <app-skeleton [width]="width" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
                  </th>
                }
              </tr>
              <tr class="skl-table__filters">
                <th><app-skeleton width="100%" height="34px" borderRadius="4px" marginBottom="0"></app-skeleton></th>
                <th><app-skeleton width="100%" height="34px" borderRadius="4px" marginBottom="0"></app-skeleton></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (row of rows; track row) {
                <tr>
                  <td><app-skeleton [width]="row % 2 === 0 ? '74%' : '68%'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton></td>
                  <td><app-skeleton [width]="row % 2 === 0 ? '60%' : '52%'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton></td>
                  <td>
                    <div class="skl-actions-inline">
                      <app-skeleton width="44px" height="30px" borderRadius="4px" marginBottom="0"></app-skeleton>
                      <app-skeleton width="56px" height="30px" borderRadius="4px" marginBottom="0"></app-skeleton>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>

      <div class="skl-total-count">
        <app-skeleton width="110px" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>

      <div class="skl-pagination">
        <div class="skl-page-size">
          <app-skeleton width="126px" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
          <app-skeleton width="74px" height="32px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-pagination__buttons">
          <app-skeleton width="32px" height="32px" borderRadius="4px" marginBottom="0"></app-skeleton>
          @for (btn of [1, 2, 3, 4]; track btn) {
            <app-skeleton width="32px" height="32px" borderRadius="4px" marginBottom="0"></app-skeleton>
          }
          <app-skeleton width="32px" height="32px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>
      </div>
    </div>
  </div>
</div>